<div mat-dialog-title class="info">Adatkezelési tájékoztató</div>
<div mat-dialog-content class="mt-3">
  <div class="row ml-3">
    <div [innerHtml]="data.adatkezelesi_szoveg"></div>
  </div>
</div>
<div class="mt-3 text-right">
  <button mat-button color="accent" (click)="onCancel()">Bezárom</button>
</div>
